import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=6b34dada&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b34dada')) {
      api.createRecord('6b34dada', component.options)
    } else {
      api.reload('6b34dada', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=6b34dada&", function () {
      api.rerender('6b34dada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/comp/ImgFallback.vue"
export default component.exports